// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentListedDocument_main__h9Hcf {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: default;
}

.ComponentListedDocument_container__IHnmB {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    height: 100%;
}

.ComponentListedDocument_container_header__EBfSN {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 30px;
    color: #101417;
}

.ComponentListedDocument_container_action_list__cHNKa {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 50px;
}

.ComponentListedDocument_action_list_left__PzpZ2 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.ComponentListedDocument_action_list_right__yWVIV {

}

.ComponentListedDocument_container_content__ezwJe,
.ComponentListedDocument_container_detail_list_box__YdDL1,
.ComponentListedDocument_container_component_content__8ydy\\+ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: calc(100% - 50px);
}

.ComponentListedDocument_container_detail_list_box__YdDL1 {
    align-items: flex-start;
}

.ComponentListedDocument_container_detail_list_main__M57JG {
    width: 100%;
    height: 100%;
}

.ComponentListedDocument_container_content_left__sHe6V,
.ComponentListedDocument_container_content_right__mPpwX {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 48%;
    height: 100%;
    border-radius: 12px;
}

.ComponentListedDocument_container_detail_list__82KSI {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ComponentListedDocument_container_detail_list__82KSI::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ComponentListedDocument_container_detail_list__82KSI::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ComponentListedDocument_container_detail_list__82KSI::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ComponentListedDocument_left_components_title__pHxa2 {
    font-size: 30px;
    font-weight: bold;
}

.ComponentListedDocument_left_components__2EC3\\+ {
    width: 100%;
    height: calc(100% - 50px);
    padding: 0 20px;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ComponentListedDocument_left_components__2EC3\\+::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ComponentListedDocument_left_components__2EC3\\+::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ComponentListedDocument_left_components__2EC3\\+::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ComponentListedDocument_more_img__9wcwF {
    width: 12px;
    height: 13px;
}

.ComponentListedDocument_shopping_model_item_box__lIKVW,
.ComponentListedDocument_components_add__1NX73 {
    width: 100%;
    padding: 10px;
    background-color: #ffffff;
    margin-bottom: 15px;
    cursor: pointer;
    border-radius: 12px;
    border: 2px solid #a6a6a6;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);
}

.ComponentListedDocument_shopping_model_item_box__lIKVW:hover {
    border: 2px solid #74BDC6;
}

.ComponentListedDocument_components_add__1NX73 {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    border: 2px solid #fff;
}

.ComponentListedDocument_components_add__1NX73:hover {
    background-color: #f2f8f9;
}

.ComponentListedDocument_shopping_model_item_box_select__iAnft {
    border: 2px solid #74BDC6;
}

.ComponentListedDocument_shopping_model_item__If8LG {
    display: flex;
    justify-content: space-between;
    width: 100%;
    /* height: 93px; */
    padding: 10px 7px;
    border-radius: 12px;
}

.ComponentListedDocument_shopping_model_img_box__3wLPs {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 51px;
    min-width: 51px;
    height: 51px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    background-color: #FFF;
}

.ComponentListedDocument_shopping_model_img__agsCt {
    width: 38px;
    height: 38px;
}

.ComponentListedDocument_shopping_model_text_box__SV1rL {
    width: calc(100% - 51px - 115px);
    padding: 0 5px;
}

.ComponentListedDocument_shopping_model_text_box_unowned__uTexN {
    padding: 0 10px 0 14px;
}

.ComponentListedDocument_shopping_model_text_title__uvqAU {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
}

.ComponentListedDocument_shopping_model_text_info__ww3eu {
    display: -webkit-box;        /* 创建一个弹性盒子 */
    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */
    -webkit-line-clamp: 3;       /* 限制显示两行 */
    overflow: hidden;            /* 隐藏超出内容 */
    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */
    color: #414648;
    font-size: 12px;
    line-height: 20px;
}

.ComponentListedDocument_shopping_model_butn__IcAVI {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    border-radius: 6px;
    font-size: 11px;
}

.ComponentListedDocument_shopping_model_owned__stG7Z {
    width: 83px;
    min-width: 83px;
    color: #74bdc6;
    background-color: #e4f0f2;
    border: 1px solid #74bdc6;
    border-bottom-width: 2px;
}

.ComponentListedDocument_shopping_model_purchase__0ytzZ {
    width: 128px;
    min-width: 128px;
    color: #EABC4E;
    background-color: #FFF;
    border: 1px solid #D9D9D9;
    border-bottom-width: 2px;
}

.ComponentListedDocument_model_status_img__X8upt {
    margin-right: 5px;
}

.ComponentListedDocument_right_header_img_box__KEz4L {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 118px;
    height: 118px;
}

.ComponentListedDocument_right_header_img__s\\+\\+u8 {
    width: 100px;
    height: 100px;
}

.ComponentListedDocument_right_header_text_box__ihfmu {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.ComponentListedDocument_right_header_text__csEoQ {
    margin-bottom: 10px;
}

.ComponentListedDocument_introduce_box__yOAIK,
.ComponentListedDocument_example_box__BlHGu {
    width: 100%;
    padding: 10px 0;
}

.ComponentListedDocument_introduce_title__3FNud,
.ComponentListedDocument_example_title__vpz6W {
    padding: 0 0 5px 10px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
}

.ComponentListedDocument_introduce_text__GUlB7,
.ComponentListedDocument_example_text__CAN7h {
    width: 100%;
    padding: 10px;
    border: 1px solid #D9D9D9;
    background-color: #f9f9f9;
    border-radius: 12px;
    font-size: 12px;
    color: #414648;
}

.ComponentListedDocument_action_list__NCDHx {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 115px;
}

.ComponentListedDocument_left_components_add__PDOyE {
    width: 100%;
    height: 50px;
    font-size: 30px;
}

.ComponentListedDocument_card_box_add__VX-Th,
.ComponentListedDocument_card_box__YtJeX {
    position: relative;
    width: 265px;
    margin: 0 15px 15px 0;
    min-height: 250px;
    max-height: 300px;
}

.ComponentListedDocument_card_box_add__VX-Th {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    border-radius: 6px;
    cursor: pointer;
}

.ComponentListedDocument_card_box_select__TmMHZ .ComponentListedDocument_card_box_cover__lGIzd {
    display: block;
}

.ComponentListedDocument_card_box_cover__lGIzd {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 265px;
    height: 300px;
    z-index: 11;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.1);
    cursor: pointer;
}

.ComponentListedDocument_select_img_box__mPRjE {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 32px;
    height: 32px;
    background-color: #fff;
    border-radius: 32px;
}

.ComponentListedDocument_card_box_cover_select__IZHcD,
.ComponentListedDocument_card_box_cover_unselect__bnUQT {

}

.ComponentListedDocument_detail_card__iPwAF .ant-card-meta-detail .ant-card-meta-title {
    font-size: 12px;
    white-space: wrap;
}

.ComponentListedDocument_detail_card__iPwAF .ant-card-body {
    padding: 5px !important;
}

.ComponentListedDocument_card_info_box__QF37z {

}

.ComponentListedDocument_card_img__NW5Tp {
    width: 265px;
    height: 200px;
}

.ComponentListedDocument_card_action_box__eLHRG {
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
}

.ComponentListedDocument_card_action_img_box__72tBn {
    width: 25px;
    height: 25px;
    margin-left: 10px;
}

.ComponentListedDocument_card_action_img_box__72tBn:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.ComponentListedDocument_card_action_img__cXVoq {
    width: 25px;
    height: 25px;
}

.ComponentListedDocument_card_label_box__V-AMx {
    width: 100px;
    height: 25px;
}

.ComponentListedDocument_card_tag__kwfA7,
.ComponentListedDocument_card_untag__zw0\\+p {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: #6fda72;
    border-radius: 6px;
}

.ComponentListedDocument_card_untag__zw0\\+p {
    background-color: #66b6f1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ComponentListedDocument/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;;AAEA;;AAEA;;;IAGI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,0EAA2C,UAAU;IACjD,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,gFAAiD,WAAW;IACxD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,qEAAqC,UAAU;IAC3C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,2EAA2C,WAAW;IAClD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB,SAAS,aAAa;IAC1C,4BAA4B,EAAE,oBAAoB;IAClD,qBAAqB,QAAQ,WAAW;IACxC,gBAAgB,aAAa,WAAW;IACxC,uBAAuB,MAAM,iBAAiB;IAC9C,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;;AAGA;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;AAEA;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".main {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    cursor: default;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 80%;\n    height: 100%;\n}\n\n.container_header {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    height: 50px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 30px;\n    color: #101417;\n}\n\n.container_action_list {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 50px;\n}\n\n.action_list_left {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.action_list_right {\n\n}\n\n.container_content,\n.container_detail_list_box,\n.container_component_content {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: calc(100% - 50px);\n}\n\n.container_detail_list_box {\n    align-items: flex-start;\n}\n\n.container_detail_list_main {\n    width: 100%;\n    height: 100%;\n}\n\n.container_content_left,\n.container_content_right {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 48%;\n    height: 100%;\n    border-radius: 12px;\n}\n\n.container_detail_list {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    max-height: 100%;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.container_detail_list::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.container_detail_list::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.container_detail_list::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.left_components_title {\n    font-size: 30px;\n    font-weight: bold;\n}\n\n.left_components {\n    width: 100%;\n    height: calc(100% - 50px);\n    padding: 0 20px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.left_components::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.left_components::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.left_components::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.more_img {\n    width: 12px;\n    height: 13px;\n}\n\n.shopping_model_item_box,\n.components_add {\n    width: 100%;\n    padding: 10px;\n    background-color: #ffffff;\n    margin-bottom: 15px;\n    cursor: pointer;\n    border-radius: 12px;\n    border: 2px solid #a6a6a6;\n    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.25);\n}\n\n.shopping_model_item_box:hover {\n    border: 2px solid #74BDC6;\n}\n\n.components_add {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 60px;\n    border: 2px solid #fff;\n}\n\n.components_add:hover {\n    background-color: #f2f8f9;\n}\n\n.shopping_model_item_box_select {\n    border: 2px solid #74BDC6;\n}\n\n.shopping_model_item {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    /* height: 93px; */\n    padding: 10px 7px;\n    border-radius: 12px;\n}\n\n.shopping_model_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 51px;\n    min-width: 51px;\n    height: 51px;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n    background-color: #FFF;\n}\n\n.shopping_model_img {\n    width: 38px;\n    height: 38px;\n}\n\n.shopping_model_text_box {\n    width: calc(100% - 51px - 115px);\n    padding: 0 5px;\n}\n\n.shopping_model_text_box_unowned {\n    padding: 0 10px 0 14px;\n}\n\n.shopping_model_text_title {\n    width: 100%;\n    height: 28px;\n    line-height: 28px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n}\n\n.shopping_model_text_info {\n    display: -webkit-box;        /* 创建一个弹性盒子 */\n    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */\n    -webkit-line-clamp: 3;       /* 限制显示两行 */\n    overflow: hidden;            /* 隐藏超出内容 */\n    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */\n    color: #414648;\n    font-size: 12px;\n    line-height: 20px;\n}\n\n.shopping_model_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 28px;\n    border-radius: 6px;\n    font-size: 11px;\n}\n\n.shopping_model_owned {\n    width: 83px;\n    min-width: 83px;\n    color: #74bdc6;\n    background-color: #e4f0f2;\n    border: 1px solid #74bdc6;\n    border-bottom-width: 2px;\n}\n\n.shopping_model_purchase {\n    width: 128px;\n    min-width: 128px;\n    color: #EABC4E;\n    background-color: #FFF;\n    border: 1px solid #D9D9D9;\n    border-bottom-width: 2px;\n}\n\n.model_status_img {\n    margin-right: 5px;\n}\n\n.right_header_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 118px;\n    height: 118px;\n}\n\n.right_header_img {\n    width: 100px;\n    height: 100px;\n}\n\n.right_header_text_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.right_header_text {\n    margin-bottom: 10px;\n}\n\n.introduce_box,\n.example_box {\n    width: 100%;\n    padding: 10px 0;\n}\n\n.introduce_title,\n.example_title {\n    padding: 0 0 5px 10px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n}\n\n.introduce_text,\n.example_text {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #D9D9D9;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n    font-size: 12px;\n    color: #414648;\n}\n\n.action_list {\n    display: flex;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    width: 115px;\n}\n\n.left_components_add {\n    width: 100%;\n    height: 50px;\n    font-size: 30px;\n}\n\n.card_box_add,\n.card_box {\n    position: relative;\n    width: 265px;\n    margin: 0 15px 15px 0;\n    min-height: 250px;\n    max-height: 300px;\n}\n\n.card_box_add {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: #ffffff;\n    border-radius: 6px;\n    cursor: pointer;\n}\n\n.card_box_select .card_box_cover {\n    display: block;\n}\n\n.card_box_cover {\n    display: none;\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 265px;\n    height: 300px;\n    z-index: 11;\n    border-radius: 6px;\n    background-color: rgba(0, 0, 0, 0.1);\n    cursor: pointer;\n}\n\n.select_img_box {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    width: 32px;\n    height: 32px;\n    background-color: #fff;\n    border-radius: 32px;\n}\n\n.card_box_cover_select,\n.card_box_cover_unselect {\n\n}\n\n.detail_card :global(.ant-card-meta-detail .ant-card-meta-title) {\n    font-size: 12px;\n    white-space: wrap;\n}\n\n.detail_card :global(.ant-card-body) {\n    padding: 5px !important;\n}\n\n.card_info_box {\n\n}\n\n.card_img {\n    width: 265px;\n    height: 200px;\n}\n\n.card_action_box {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 10px;\n}\n\n.card_action_img_box {\n    width: 25px;\n    height: 25px;\n    margin-left: 10px;\n}\n\n.card_action_img_box:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n.card_action_img {\n    width: 25px;\n    height: 25px;\n}\n\n.card_label_box {\n    width: 100px;\n    height: 25px;\n}\n\n.card_tag,\n.card_untag {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    background-color: #6fda72;\n    border-radius: 6px;\n}\n\n.card_untag {\n    background-color: #66b6f1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ComponentListedDocument_main__h9Hcf`,
	"container": `ComponentListedDocument_container__IHnmB`,
	"container_header": `ComponentListedDocument_container_header__EBfSN`,
	"container_action_list": `ComponentListedDocument_container_action_list__cHNKa`,
	"action_list_left": `ComponentListedDocument_action_list_left__PzpZ2`,
	"action_list_right": `ComponentListedDocument_action_list_right__yWVIV`,
	"container_content": `ComponentListedDocument_container_content__ezwJe`,
	"container_detail_list_box": `ComponentListedDocument_container_detail_list_box__YdDL1`,
	"container_component_content": `ComponentListedDocument_container_component_content__8ydy+`,
	"container_detail_list_main": `ComponentListedDocument_container_detail_list_main__M57JG`,
	"container_content_left": `ComponentListedDocument_container_content_left__sHe6V`,
	"container_content_right": `ComponentListedDocument_container_content_right__mPpwX`,
	"container_detail_list": `ComponentListedDocument_container_detail_list__82KSI`,
	"left_components_title": `ComponentListedDocument_left_components_title__pHxa2`,
	"left_components": `ComponentListedDocument_left_components__2EC3+`,
	"more_img": `ComponentListedDocument_more_img__9wcwF`,
	"shopping_model_item_box": `ComponentListedDocument_shopping_model_item_box__lIKVW`,
	"components_add": `ComponentListedDocument_components_add__1NX73`,
	"shopping_model_item_box_select": `ComponentListedDocument_shopping_model_item_box_select__iAnft`,
	"shopping_model_item": `ComponentListedDocument_shopping_model_item__If8LG`,
	"shopping_model_img_box": `ComponentListedDocument_shopping_model_img_box__3wLPs`,
	"shopping_model_img": `ComponentListedDocument_shopping_model_img__agsCt`,
	"shopping_model_text_box": `ComponentListedDocument_shopping_model_text_box__SV1rL`,
	"shopping_model_text_box_unowned": `ComponentListedDocument_shopping_model_text_box_unowned__uTexN`,
	"shopping_model_text_title": `ComponentListedDocument_shopping_model_text_title__uvqAU`,
	"shopping_model_text_info": `ComponentListedDocument_shopping_model_text_info__ww3eu`,
	"shopping_model_butn": `ComponentListedDocument_shopping_model_butn__IcAVI`,
	"shopping_model_owned": `ComponentListedDocument_shopping_model_owned__stG7Z`,
	"shopping_model_purchase": `ComponentListedDocument_shopping_model_purchase__0ytzZ`,
	"model_status_img": `ComponentListedDocument_model_status_img__X8upt`,
	"right_header_img_box": `ComponentListedDocument_right_header_img_box__KEz4L`,
	"right_header_img": `ComponentListedDocument_right_header_img__s++u8`,
	"right_header_text_box": `ComponentListedDocument_right_header_text_box__ihfmu`,
	"right_header_text": `ComponentListedDocument_right_header_text__csEoQ`,
	"introduce_box": `ComponentListedDocument_introduce_box__yOAIK`,
	"example_box": `ComponentListedDocument_example_box__BlHGu`,
	"introduce_title": `ComponentListedDocument_introduce_title__3FNud`,
	"example_title": `ComponentListedDocument_example_title__vpz6W`,
	"introduce_text": `ComponentListedDocument_introduce_text__GUlB7`,
	"example_text": `ComponentListedDocument_example_text__CAN7h`,
	"action_list": `ComponentListedDocument_action_list__NCDHx`,
	"left_components_add": `ComponentListedDocument_left_components_add__PDOyE`,
	"card_box_add": `ComponentListedDocument_card_box_add__VX-Th`,
	"card_box": `ComponentListedDocument_card_box__YtJeX`,
	"card_box_select": `ComponentListedDocument_card_box_select__TmMHZ`,
	"card_box_cover": `ComponentListedDocument_card_box_cover__lGIzd`,
	"select_img_box": `ComponentListedDocument_select_img_box__mPRjE`,
	"card_box_cover_select": `ComponentListedDocument_card_box_cover_select__IZHcD`,
	"card_box_cover_unselect": `ComponentListedDocument_card_box_cover_unselect__bnUQT`,
	"detail_card": `ComponentListedDocument_detail_card__iPwAF`,
	"card_info_box": `ComponentListedDocument_card_info_box__QF37z`,
	"card_img": `ComponentListedDocument_card_img__NW5Tp`,
	"card_action_box": `ComponentListedDocument_card_action_box__eLHRG`,
	"card_action_img_box": `ComponentListedDocument_card_action_img_box__72tBn`,
	"card_action_img": `ComponentListedDocument_card_action_img__cXVoq`,
	"card_label_box": `ComponentListedDocument_card_label_box__V-AMx`,
	"card_tag": `ComponentListedDocument_card_tag__kwfA7`,
	"card_untag": `ComponentListedDocument_card_untag__zw0+p`
};
export default ___CSS_LOADER_EXPORT___;
